import http from '../clients/Axios'

export default class JobService {
  async get() {
    const res = await http.get('/dashboard')
    return res.data
  }
}
